module.exports = __webpack_public_path__ + "static/media/mobileStats.20fe8414.jpg";